export interface RestrictionState {
    disabled: boolean;
    hidden: boolean;
}

// Feature level restrictions
export const RESTRICTION_RF_PLANNING = 'rfPlanning';
export const RESTRICTION_PATH_PROFILING = 'pathProfiling';
export const RESTRICTION_HEATMAP = 'heatmap';
export const RESTRICTION_ZONES = 'zones';
export const RESTRICTION_TERRAIN = 'terrain';
export const RESTRICTION_ACTIVITY = 'activity';
export const RESTRICTION_IMAGERY_LAYERS = 'imageryLayers';
export const RESTRICTION_FEATURE_LAYERS = 'featureLayers';
export const RESTRICTION_MAP_LAYERS = 'mapLayers';
export const RESTRICTION_AGGREGATE_TABLE = 'aggregateTable';
export const RESTRICTION_STAT_BROWSER = 'statBrowser';
export const RESTRICTION_REPORTS = 'reports';
export const RESTRICTION_TICKETS = 'tickets';
export const RESTRICTION_TRIGGERS = 'triggers';
export const RESTRICTION_QUERY_TAB = 'query';
export const RESTRICTION_LOGICAL_VIEWS = 'logicalViews';
export const RESTRICTION_IP_DEVICE = 'ipDeviceAndZone';

/**
 * false: (restricted), visible in the UI but disabled
 *
 * true: (unrestricted), visible and usable in the UI
 *
 * null: hidden from the UI completely
 */
export interface RestrictionsServiceState {
    [RESTRICTION_RF_PLANNING]: boolean | null;
    [RESTRICTION_PATH_PROFILING]: boolean | null;
    [RESTRICTION_HEATMAP]: boolean | null;
    [RESTRICTION_ZONES]: boolean | null;
    [RESTRICTION_TERRAIN]: boolean | null;
    [RESTRICTION_IMAGERY_LAYERS]: boolean | null;
    [RESTRICTION_FEATURE_LAYERS]: boolean | null;
    [RESTRICTION_ACTIVITY]: boolean | null;
    [RESTRICTION_MAP_LAYERS]: boolean | null;
    [RESTRICTION_REPORTS]: boolean | null;
    [RESTRICTION_STAT_BROWSER]: boolean | null;
    [RESTRICTION_TICKETS]: boolean | null;
    [RESTRICTION_TRIGGERS]: boolean | null;
    [RESTRICTION_QUERY_TAB]: boolean | null;
    [RESTRICTION_LOGICAL_VIEWS]: boolean | null;
    [RESTRICTION_IP_DEVICE]: boolean | null;
    [RESTRICTION_AGGREGATE_TABLE]: boolean | null;
}

export abstract class AbstractRestrictionsService {
    private static isDisabled = (restriction: boolean | null): boolean => {
        if (restriction === null || restriction === undefined) {
            return false;
        }
        return !restriction;
    };

    private static isHidden = (restriction: boolean | null): boolean => {
        // Hides when restriction is disabled or not loaded from the API yet i.e. hide by default
        return restriction === null || restriction === undefined;
    };

    abstract subscribeToChanges(
        fn: (restrictions: Readonly<RestrictionsServiceState>) => void,
    ): () => void;

    public static get(restriction: boolean | null): Readonly<RestrictionState> {
        return {
            disabled: this.isDisabled(restriction),
            hidden: this.isHidden(restriction),
        };
    }
}

export function getEmptyRestrictionState(): RestrictionsServiceState {
    return {
        [RESTRICTION_RF_PLANNING]: false,
        [RESTRICTION_PATH_PROFILING]: false,
        [RESTRICTION_HEATMAP]: false,
        [RESTRICTION_IMAGERY_LAYERS]: false,
        [RESTRICTION_FEATURE_LAYERS]: false,
        [RESTRICTION_MAP_LAYERS]: false,
        [RESTRICTION_ZONES]: false,
        [RESTRICTION_TERRAIN]: false,
        [RESTRICTION_ACTIVITY]: false,
        [RESTRICTION_REPORTS]: false,
        [RESTRICTION_STAT_BROWSER]: false,
        [RESTRICTION_TICKETS]: false,
        [RESTRICTION_TRIGGERS]: false,
        [RESTRICTION_QUERY_TAB]: false,
        [RESTRICTION_LOGICAL_VIEWS]: false,
        [RESTRICTION_IP_DEVICE]: false,
        [RESTRICTION_AGGREGATE_TABLE]: false,
    };
}
